// When to load a pedigree, and what to do when the load fails (TGCLOUD-1618).
//
// Pure, so the two rules with real consequences are pinned by tests instead of only
// being reachable by mounting the whole chart in jsdom.
//
// THE BUG THESE EXIST FOR. The multi-pedigree workspace keeps every open tab
// MOUNTED, one PedigreeChartView each. Each fetched its family on mount and, on
// failure, called `navigate(pedigreeToolPath)` — a global router navigation. So a
// single tab the current user could not load (another tenant's family inherited
// through sessionStorage across a login, or one since deleted or merged) threw the
// whole app back to the family list, every time, from every pedigree. The reported
// symptom was "no pedigree will open, and a family I just created won't open
// either": it loaded fine and was then evicted by its stale neighbours.

// Whether this instance should fetch its family now.
//
// `hasBeenActive` latches: a tab loads when it first becomes the active one, not
// when it mounts. On entry to the pedigree route that is the difference between one
// full-family load and one per open tab — and each load carries `auditView=1`,
// which writes a Tier-2 "record opened" audit event, so eager loading recorded the
// user as having opened every tab when they opened one.
export const shouldFetchFamily = ({
  familyId,
  sessionInaccessible,
  hasBeenActive
}) => Boolean(familyId) && !sessionInaccessible && Boolean(hasBeenActive);

// What a failed load should do. Returns the three effects separately so the caller
// stays a thin wiring layer and each rule is asserted on its own.
export const familyLoadFailureEffects = ({
  isPreview,
  workspaceMode,
  isActive
}) => {
  // A read-only FHQ preview is not a tab and owns its own error handling.
  if (isPreview) {
    return {
      notifyPreview: true,
      markInaccessible: false,
      navigateToList: false
    };
  }
  return {
    notifyPreview: false,
    // Flag the session so it is never retried. Without this the tab re-fetches on
    // every visit to the pedigree route and fails again — the retry, not the first
    // failure, is what produced the lockout.
    markInaccessible: workspaceMode,
    // Only the ACTIVE tab may move the router. A hidden background tab that
    // navigates evicts the user from the pedigree they are actually looking at.
    // Outside the workspace (single chart) there is nothing to be background TO,
    // so the classic behaviour is unchanged.
    navigateToList: !workspaceMode || isActive
  };
};
